export default __webpack_public_path__ + "static/media/logo_iss_fullcolor.4971c825.svg";